<template>
  <v-container class="cmp-contacts-contacts-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <ContactDetails :contact="selectedContact.contact"></ContactDetails>
      <glayout
        :tabs="contactSidewindowTabs"
        :menu="[
          {
            text: $t('export_vcard'),
            value: 'export_vcard'
          },
          {
            text: $t('duplicate_contact'),
            value: 'duplicate_contact'
          },
          {
            text: $t('delete_contact'),
            value: 'delete_contact',
            error: true
          }
        ]"
        :loading="selectedContact && selectedContact.loading"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('contact')" :h="isCompany?'356':'388'">
                <ContactInfo
                  :contact="selectedContact"
                  :accountingInfo="accountingInfo"
                  :vatIdValidity="vatIdValidity"
                  :vatIdValidityLoading="vatIdValidityLoading"
                  @changed="onContactChange"
                />
              </gbox>
              <gbox 
                :title="$t('notes')" 
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :value="selectedContact.contact.notes"
                  :id="'notes'"
                  @blur="onSelectedContactNoteBlur"
                />
              </gbox>
            </gcol>

            <gcol>
              <gbox :title="$t('communication_info')" h="258.5">
                <CommunicationInfo
                  :contact="selectedContact.contact"
                  :vatIdValidity="vatIdValidity"
                  :vatIdValidityLoading="vatIdValidityLoading"
                  @changed="onContactChange"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedContact &&
                      selectedContact.contact_relations &&
                      selectedContact.contact_relations.length
                  )
                "
                :title="$t('related_contacts')"
              >
                <RealtedContacts
                  :contact_relations="selectedContact.contact_relations"
                  :external_id="`${this.selectedContactId}`"
                  :external_table="contact_relation_table"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedContact &&
                      selectedContact.related_groups &&
                      selectedContact.related_groups.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('submenu_GROUPS')"
              >
                <DBoxGroups
                  :groups="selectedContact.related_groups"
                  :contact_id="`${this.selectedContact.contact.contact_id}`"
                  @delete="onGroupDelete"
                  @groupClick="onGroupClick"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="additional_info">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedContact &&
                      selectedContact.files &&
                      selectedContact.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedContact.files"
                  :externalId="`${this.selectedContactId}`"
                  :externalTable="'contacts'"
                  @fileDelete="onFileDelete"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
            
                :h="boxHeightNamed({
                  rowCount: selectedContact &&
                        selectedContact.fields &&
                        selectedContact.fields.length,
                  offset: NTOffsets.WithDBoxBottom,
                  rowHeight:32.5,
                  max: 15,
                  min:1
                })"
                :title="$t('tab_title_custom_fields')"
              >
                <CustomFields
                  :fields="selectedContact.fields"
                  :section="'contacts'"
                  :externalId="selectedContactId"
                  :externalTable="'contacts'"
                  :module="'contacts'"
                  @changed="onCustomFieldsChanged"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="accounting_info" :title="$t('tab_title_accounting_info')">
          <grow>
            <gcol>
              <gbox :title="$t('accounting_details')" h="292">
                <AccountingDetails
                  :accountingInfo="accountingInfo"
                  :vatIdValidity="vatIdValidity"
                  :vatIdValidityLoading="vatIdValidityLoading"
                  @changed="onAccountingInfoChange"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    filteredPayment_provider_data.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('bank_details')"
              >
                <BankDetails
                  @add_click="onOpenBankDialog"
                  v-if="accountingInfo && accountingInfo.payment_provider_data"
                  :selectedContactId="selectedContactId"
                  :accountingInfo="accountingInfo"
                  @editOpenDialog="onEditOpenDialog"
                  @delete="onPaymentProviderDelete"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('outgoing_invoices_txt')" h="195">
                <PaymentTerms
                  :accountingInfo="accountingInfo"
                  :pt_prefix="'invoice'"
                  @changed="onAccountingInfoChange"
                />
              </gbox>
              <gbox :title="$t('incoming_invoices_txt')" h="195">
                <PaymentTerms
                  :accountingInfo="accountingInfo"
                  :pt_prefix="'cost'"
                  @changed="onAccountingInfoChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_invoices">
          <grow>
            <gcol>
              <gbox
                :title="$t('invoice')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      accountingInfo &&
                      accountingInfo.invoices &&
                      accountingInfo.invoices.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
              >
                <InvoiceList
                  :accountingInfo="accountingInfo"
                  :invoiceKey="'invoices'"
                  @changed="onAccountingInfoChange"
                />
              </gbox>
              <gbox
                :title="$t('tab_title_costs')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      accountingInfo &&
                      accountingInfo.costs &&
                      accountingInfo.costs.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
              >
                <InvoiceList
                  :accountingInfo="accountingInfo"
                  :invoiceKey="'costs'"
                  @changed="onAccountingInfoChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <v-dialog v-model="paymentProviderDialog" width="390">
      <PaymentProviderDialog
        :accountingInfo="accountingInfo"
        :isEdit="isEdit"
        :paymentProviderTitle="paymentProviderTitle"
        :paymentProviderKey="paymentProviderKey"
        @cancelled="onDialogCancelled"
        @create_edit="onCreateEdit"
        @on_delete="onDeleteItem"
        v-if="accountingInfo && accountingInfo.payment_provider_data"
      >
      </PaymentProviderDialog>
    </v-dialog>
  </v-container>
</template>

<script>
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";

import {
  createGridHost,
  createSidewindowTabulation
} from "../../../../dt-plugins/sidewindow";
import { contactDetailsGrid, contactGridItemRouteMap } from "./sw-grid";

import ContactDetails from "./contact-details";
import ContactInfo from "./contact-info";
import AccountingDetails from "./accounting-details";
import TaxDetails from "./tax-details";
import BankDetails from "./bank-details";
import InvoiceList from "./invoice-list";
import CostList from "./cost-list";
import PaymentTerms from "./payment-terms";
import PaymentProviderDialog from "./payment-provider-dialog";

import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import CommunicationInfo from "@/dt-plugins/dbox-communication/communication";
import DBoxTextarea from "@/dt-plugins/dbox-textarea/dbox-textarea";
import DBoxGroups from "@/dt-plugins/groups/dbox-groups";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import CustomFields from "@/dt-plugins/custom-fields/custom-fields";

import { ContactsService } from "../../services/contacts.service";
import { contactListLDTRoutes } from "../../router/routes";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import {
  checkTabListPermission,
  checkTabGridItemPermission
} from "../../../../router/guard";
import { ContactFuncs } from "../../models/contacts.model";

export const moduleRoute = "contacts";
export const submenuRoute = "contact_list";

import { deleteContact } from "./contact-list";
import { dispatch } from "rxjs/internal/observable/pairs";
import {
  contactGroupsListLDTRoutes,
  getContactGroupDetailsSelectable
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails
} from "../../../../utility/route";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { getNoteRow } from '../../../../utility';
import { createContactDetails } from "../../models/contact-details.model";

export default {
  components: {
    ContactInfo,
    RealtedContacts,
    CommunicationInfo,
    DBoxTextarea,
    DBoxGroups,
    DBoxFiles,
    CustomFields,
    ContactDetails,
    PaymentTerms,

    AccountingDetails,
    TaxDetails,
    BankDetails,
    InvoiceList,
    CostList,
    PaymentProviderDialog
  },
  data: function() {
    return {
      active: -1,
      bankDetailsDialog: false,
      paymentProviderDialog: false,

      paymentProviderTitle: "",
      paymentProviderKey: "",
      isEdit: false,

      // Vat Validity Data

      vatIdValidity: false,
      vatIdValidityLoading: null
    };
  },
  mixins: [createDTGridHost()],
  mounted: function() {
    // this.routeMount();
  },
  watch: {
    accountingInfo: {
      immediate: true,
      handler: function(to, from) {
        if (to.check_vat_id) {
          // this.vatIdValidityLoading = false;
          this.vatIdValidity = to.check_vat_id == 1 ? true : false;
        } else if (Object.keys(to) == 0) {
          // this.vatIdValidityLoading = true;
        } else {
          // this.vatIdValidityLoading = false;
          this.vatIdValidity = false;
        }

        console.log({ to, keys: Object.keys(to) });
        // if (to == {}) {

        // }
      }
    }
  },
  computed: {
    ...mapGetters(storeNS, {
      // selectedContact: "selectedContact",
      selectedContactLoading: "selectedContactLoading",
      contactDetailsGrid: "contactDetailsGrid",
      // accountingInfo: "accountingInfo",
      contactDetails: "contactDetails"
    }),
    contact_id: function() {
      return this.$route.params.contact_id;
    },
    selectedContact: function() {
      const contactDefault = {contact: {}};
      const selectedContactDetails =  (this.contactDetails || [])[this.contact_id] || contactDefault;
      return {...selectedContactDetails};
    },
    accountingInfo: function() {
      return this.selectedContact;
    },
    selectedContactId: function() {
      console.log("this.selectedContact:::", this.selectedContact);

      return this.selectedContact.contact.contact_id;
    },
    contact_relation_table: function() {
      // return this.selectedContact.contact.getExternalTable();
      const { first_name } = this.selectedContact;
      return first_name ? `contacts_individual` : `contacts`
    },
    contactSidewindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info")
        },
        {
          route: "additional_info",
          value: this.$t("additional_infos")
        },
        {
          route: "accounting_info",
          value: this.$t("tab_title_accounting_info")
        },
        {
          route: "tab_title_invoices",
          value: this.$t("tab_title_invoices")
        }
      ]);
    },

    isCompany: function() {
      console.log({
        contact: this.selectedContact?.contact,
        "ContactFuncs.isCompany(this.selectedContact?.contact || {})": ContactFuncs.isCompany(
          this.selectedContact?.contact || {}
        )
      });
      return ContactFuncs.isCompany(this.selectedContact?.contact || {});
    },
    payment_provider_data: function() {
      const payment_provider_data = this.accountingInfo?.payment_provider_data;
      return Object.keys(payment_provider_data || {}).map(providerName => {
        return {
          providerName,
          ...payment_provider_data[providerName]
        };
      });
    },
    filteredPayment_provider_data: function() {
      return (
        this.payment_provider_data?.filter(
          e => e.providerName && e.providerName.length > 0
        ) || []
      );
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.SelectedContactGroups.DELETE.SINGLE]:
        ActionTypes.SelectedContactGroups.DELETE.SINGLE,
      [ActionTypes.SelectedContact.UPDATE.SINGLE]:
        ActionTypes.SelectedContact.UPDATE.SINGLE,
      [ActionTypes.SelectedContactRelatedContacts.UPDATE.SINGLE]:
        ActionTypes.SelectedContactRelatedContacts.UPDATE.SINGLE,
      [ActionTypes.SelectedContactRelatedContacts.DELETE.SINGLE]:
        ActionTypes.SelectedContactRelatedContacts.DELETE.SINGLE,
      [ActionTypes.ContactFiles.DELETE.SINGLE]:
        ActionTypes.ContactFiles.DELETE.SINGLE,
      [ActionTypes.ContactFields.SET.ALL]: ActionTypes.ContactFields.SET.ALL,
      [ActionTypes.SET_PROVIDER_DATA]: ActionTypes.SET_PROVIDER_DATA,
      [ActionTypes.ContactAccountingInfo.UPDATE.ALL]:
        ActionTypes.ContactAccountingInfo.UPDATE.ALL,
      [ActionTypes.SelectedContact.SET.SINGLE]:
        ActionTypes.SelectedContact.SET.SINGLE,
      [ActionTypes.DELETE_PAYMENT_PROVIDER]: ActionTypes.DELETE_PAYMENT_PROVIDER,
      [ActionTypes.ContactDetails.FETCH.SINGLE]: ActionTypes.ContactDetails.FETCH.SINGLE
    }),

    getNoteRow:getNoteRow,

    closeContactDetails: function() {
      this.$emit("closeContactSidewindow", true);
    },
    onSelectedContactNoteBlur: function(event) {
      console.log(event);
      const { value } = event.target;
      this[ActionTypes.SelectedContact.UPDATE.SINGLE]({
        name: "notes",
        value
      });
    },
    onGroupClick: function(item) {
      onDetailsRowClicked(this.$router, item, contactGroupsListLDTRoutes);
    },
    onGroupDelete: function(group) {
      this[ActionTypes.SelectedContactGroups.DELETE.SINGLE](group);
    },
    onContactChange: function({ name, value }) {
      this[ActionTypes.SelectedContact.UPDATE.SINGLE]({
        name,
        value,
        promoter_id: this.selectedContact.promoter
      });
      this.syncVatNoChange(name, value, "contact_info");
    },
    syncVatNoChange(name, value, from = "contact_info") {
      if (name == "vat_no") {
        this.vatIdValidityLoading = true;

        if (from == "contact_info") {
          this[ActionTypes.ContactAccountingInfo.UPDATE.ALL]({
            kVal: this.selectedContactId,
            name,
            value
          });
        } else {
          this[ActionTypes.SelectedContact.UPDATE.SINGLE]({
            name,
            value
          });
        }

        setTimeout(() => {
          ContactsService.checkVatIdFlag({
            vat_no: value,
            contact_id: this.selectedContactId
          }).then(res => {
            // console.log("::::",res)
            this.vatIdValidity = res.data.valid == "0" ? false : true;
            this.vatIdValidityLoading = false;
          });
        }, 5000);
      }
    },
    onRelatedContactDelete: function(contact) {
      this[ActionTypes.SelectedContactRelatedContacts.DELETE.SINGLE](contact);
    },
    onRelatedContactChange: function({ name, value, item }) {
      this[ActionTypes.SelectedContactRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item
      });
    },
    onRelatedContactSelected: function(contact) {
      console.log(contact);
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview"
        }
      });
    },

    onFileDelete: function(file) {
      this[ActionTypes.ContactFiles.DELETE.SINGLE](file);
    },
    onCustomFieldsChanged: function(fields) {
      this[ActionTypes.ContactFields.SET.ALL](fields);
    },
    onExportVCardClick: function() {
      const vCardURL = ContactsService.exportVCardURL({
        contact_id: this.selectedContactId
      });
      window.open(vCardURL, "VCard");
    },
    onDuplicateContactClick: async function(event) {
      const duplicatedContact = await ContactsService.duplicateContact({
        contact_id: this.selectedContactId
      });
      this.$emit("fetch", true);
      this.$router.push({
        name: contactListLDTRoutes.names.details,
        params: {
          contact_id: duplicatedContact.data.contact_id
        }
      });
    },
    onContactDelete: async function() {
      // deleteContact(
      //   this.selectedContact.contact.contact_id,
      //   ContactFuncs.getName(this.selectedContact.contact)
      // );
      this.$emit("delete", {
        contact_id: this.selectedContact.contact.contact_id,
        name: ContactFuncs.getName(this.selectedContact.contact)
      });
    },
    onProviderUpdate: function(payload) {
      this[ActionTypes.SET_PROVIDER_DATA](payload);
    },
    onAccountingInfoChange: function({ name, value }) {
      console.log(name, value);
      // if(name!="vat_no"){
      this[ActionTypes.ContactAccountingInfo.UPDATE.ALL]({
        kVal: this.selectedContactId,
        name,
        value
      });
      // }

      this.syncVatNoChange(name, value, "accounting_info");
    },

    // MARK: Methods

    onTabOptionClicked(value) {
      console.log("value", value);
      switch (value) {
        case "export_vcard":
          this.onExportVCardClick();
          console.log("kdjsl");
          break;
        case "duplicate_contact":
          this.onDuplicateContactClick();
          break;
        case "delete_contact":
          this.onContactDelete();
          break;
        default:
          break;
      }
    },

    // onTabOptionClicked(value) {
    //   console.log("value", value);
    //   if (value == "export_vcard") {
    //     this.onExportVCardClick();
    //     console.log("kdjsl");
    //   } else if (value == "duplicate_contact") {
    //     this.onDuplicateContactClick();
    //   } else {
    //     this.onContactDelete();
    //   }
    // },

    onDialogCancelled() {
      this.paymentProviderDialog = false;

      setTimeout(() => {
        this.paymentProviderTitle = "";
        this.paymentProviderKey = "";
        this.isEdit = false;
      }, 500);
    },
    onOpenBankDialog() {
      this.paymentProviderDialog = true;
      this.isEdit = false;
    },
    onEditOpenDialog(paymentProviderKey) {
      this.paymentProviderDialog = true;
      this.paymentProviderKey = paymentProviderKey;
      this.paymentProviderTitle = this.$dft.snakeCaseToWords(
        paymentProviderKey
      );
      this.isEdit = true;
    },
    onPaymentProviderDelete(payload) {
      this[ActionTypes.DELETE_PAYMENT_PROVIDER](payload);
    },

    fetchData() {
      // this[ActionTypes.SelectedContact.SET.SINGLE]({
      //   flag: true,
      //   contact: { contact_id: this.selectedContactId }
      // });

      this[ActionTypes.ContactDetails.FETCH.SINGLE]({
        flag: true,
        contact: { contact_id: this.selectedContactId },
        reload: true
      });
    },

    onCreateEdit() {
      this.onDialogCancelled();
      this.fetchData();
    },
    onDeleteItem() {
      this.onDialogCancelled();
      this.fetchData();
    }
  }
};
</script>

<style lang="scss">
.cmp-contacts-contacts-sidewindow {
  .dt-grid-layout {
   height: calc(100vh - 149px);
  }
  .overview-options {
    margin-top: 7%;
    .icons {
      display: flex;
      justify-content: center;
      img:first-child {
        padding-top: 2px;
      }
      img {
        cursor: pointer;
      }
      .loading-icon-container {
        width: 30px;
        .loading-icon {
          width: 15px;
          height: 15px;
          padding-left: 5px;
        }
      }

      .status {
        margin-top: 17px;
        margin-left: 5px;
        .circle {
          width: 15px;
          height: 15px;
          border-radius: 30px;
        }
      }
    }
  }
}
</style>
